import { useEffect, useState } from 'react';
import { CreateCartDiscountInput } from '../../../server';
import {
  useBasketDiscountAddEffect,
  useBasketDiscountRemoveEffect,
  usePageNotificationEffect,
} from '../../../state';

export function useBasketDiscountEffect() {
  const [loading, setLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string | undefined>(
    undefined
  );

  const pageNotification = usePageNotificationEffect();

  const basketDiscountAdd = useBasketDiscountAddEffect({
    onComplete: () =>
      pageNotification.add({
        type: 'default',
        styleClasses: ['toastBase'],
        title: 'Success',
        message: 'Discount added',
      }),
  });

  const basketDiscountRemove = useBasketDiscountRemoveEffect({
    onComplete: () =>
      pageNotification.add({
        type: 'default',
        styleClasses: ['toastBase'],
        title: 'Success',
        message: 'Discount removed',
      }),
  });

  const addDiscount = (data: CreateCartDiscountInput) => {
    setLoading(true);
    basketDiscountAdd.enact(data);
  };

  const removeDiscount = (id: number) => {
    setLoading(true);
    basketDiscountRemove.enact(id);
  };

  useEffect(() => {
    if (!basketDiscountAdd.loading) {
      if (basketDiscountAdd.success) {
        basketDiscountAdd.clear();
        setLoading(false);
      }

      if (basketDiscountAdd.error) {
        basketDiscountAdd.clear();
        setErrorMessage('Invalid code!');
        setLoading(false);
      }
    }

    if (!basketDiscountRemove.loading) {
      if (basketDiscountRemove.success) {
        basketDiscountRemove.clear();
        setLoading(false);
      }

      if (basketDiscountRemove.error) {
        basketDiscountRemove.clear();
        setErrorMessage('Error removing discount!');
        setLoading(false);
      }
    }
  }, [basketDiscountAdd, basketDiscountRemove]);

  return {
    loading,
    errorMessage,
    setErrorMessage,
    addDiscount,
    removeDiscount,
  };
}
